import React from 'react';

import { GetAllCareerPath } from 'services/core';
import { useQuery } from 'react-query';
import { QueryClient, dehydrate } from 'react-query';
import { queryClientConfig } from '@core/configs/queryClientConfig';
import { setSsrTokens } from 'utils/authentication';

import { getCareerPathProps } from 'router/seoprops/pages/career-path';
import { NextSeo } from 'next-seo';

import classes from './career-path.module.scss';
import ExploreCareerCard from 'components/pages/career/explorecareercard/ExploreCareerCard';

const index = () => {
    const seoProps = getCareerPathProps();
    const { data, isLoading } = useQuery(['career-paths'], GetAllCareerPath);
    return (
        <>
            <NextSeo {...seoProps} />
            <div className='container px-xl-0'>
                <div className='row d-flex justify-content-center'>
                    <div className='col-xl-10 col-12'>
                        <div className={classes['wrapper']}>
                            <div className={classes['header']}>
                                <h2>Explore Your Future in Pharma</h2>
                                <p>
                                    Discover tailored career paths designed to help you grow in the pharmaceutical industry.
                                    Whether you're just starting out or looking to specialize, find the roles, skills, and
                                    learning steps that align with your goals.
                                </p>
                            </div>
                            <div className={classes['card-wrapper']}>
                                {(data && !isLoading) && (
                                    <>
                                        {data?.data.map((item, index) => (
                                           <ExploreCareerCard key={index} career={item} />
                                        ))}
                                    </>
                                )}
                                {isLoading && (
                                    <div className={classes['loading']}>
                                        <Spinner />
                                    </div>
                                )}
                            </div>
                        </div >
                    </div>
                </div>
            </div>
        </>
    );
};

export async function getServerSideProps(context) {
    setSsrTokens(context);
    const queryClient = new QueryClient(queryClientConfig);
    const response = await GetAllCareerPath();
    await queryClient.prefetchQuery(['career-paths'], () => ({ data: response.data }));
    return {
        props: {
            dehydratedState: dehydrate(queryClient)
        }
    };
}

export default index;